export default __webpack_public_path__ + "static/media/csd_01.019cbb44.png";